import React, { useState } from "react";
import ChatComposer from "../components/ChatComposer";
import PlanSummary from "../components/PlanSummary";
import { logUiEvent } from "../services/analytics";
import { requestPlan } from "../services/functionsClient";

const defaultPlan = {
  name: "Starter",
  monthlyCredits: 20000,
  llmModel: "gpt-5-mini-2025-08-07",
  maxApps: 5,
  maxSnapshots: 20
};

function DashboardPage() {
  const [conversation, setConversation] = useState([]);
  const [busy, setBusy] = useState(false);

  const handleSend = async ({ prompt, model, reasoningEffort, toolChoice }) => {
    logUiEvent("app_prompt_submitted", { length: prompt.length, model, reasoningEffort, toolChoice });
    setBusy(true);
    setConversation((prev) => [...prev, { role: "user", content: prompt }]);
    try {
      const planning = await requestPlan({ prompt });
      setConversation((prev) => [...prev, { role: "assistant", content: planning.plan }]);
    } catch (error) {
      setConversation((prev) => [
        ...prev,
        {
          role: "assistant",
          content: "The planner is unavailable. Please check your Firebase Functions deployment."
        }
      ]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid" style={{ gap: "16px" }}>
      <div className="panel">
        <h2 className="section-title">Describe your app</h2>
        <ChatComposer onSend={handleSend} disabled={busy} />
      </div>

      <div className="panel">
        <h3 className="section-title">Conversation</h3>
        <div className="list">
          {conversation.map((item, index) => (
            <div key={index} className="list__item">
              <div className="badge">{item.role}</div>
              <p>{item.content}</p>
            </div>
          ))}
          {conversation.length === 0 && <p className="muted">No messages yet.</p>}
        </div>
      </div>

      <PlanSummary plan={defaultPlan} />
    </div>
  );
}

export default DashboardPage;
